(() => {
  const initializeProduct = (root) => {
    const productInfo = root.matches?.('[data-hitch-product]') ? root : root.querySelector?.('[data-hitch-product]');
    if (!productInfo || productInfo.closest('quick-add-modal') || productInfo.dataset.hitchProductInitialized === 'true') return;
    productInfo.dataset.hitchProductInitialized = 'true';

    const sticky = productInfo.querySelector('[data-hitch-sticky-cart]');
    const sourceButton = productInfo.querySelector('.product-form__submit');
    const stickyButton = sticky?.querySelector('[data-hitch-sticky-submit]');
    const stickyLabel = sticky?.querySelector('[data-hitch-sticky-label]');
    const stickyPrice = sticky?.querySelector('[data-hitch-sticky-price]');
    const stickyComparePrice = sticky?.querySelector('[data-hitch-sticky-compare-price]');
    const stickyVariant = sticky?.querySelector('[data-hitch-sticky-variant]');
    const stickySelect = sticky?.querySelector('[data-hitch-sticky-select]');
    const stickyImage = sticky?.querySelector('[data-hitch-sticky-image]');
    const stickySpinner = sticky?.querySelector('[data-hitch-sticky-spinner]');

    productInfo.querySelectorAll('[data-hitch-delivery]').forEach((delivery) => {
      const minDays = Number(delivery.dataset.minDays) || 2;
      const maxDays = Number(delivery.dataset.maxDays) || 5;
      const output = delivery.querySelector('[data-hitch-delivery-text]');
      if (!output) return;
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let remaining = days;
        while (remaining > 0) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
        }
        return result;
      };
      const formatDate = (date) => new Intl.DateTimeFormat('es-CO', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      }).format(date);
      const today = new Date();
      const start = formatDate(addBusinessDays(today, minDays));
      const end = formatDate(addBusinessDays(today, Math.max(minDays, maxDays)));
      output.textContent = `entre el ${start} y el ${end}.`;
    });

    const syncSticky = () => {
      if (!sticky || !sourceButton) return;
      const price = productInfo.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
      const comparePrice = productInfo.querySelector('[id^="price-"] .price-item--regular s, [id^="price-"] .price__sale s');
      const selections = Array.from(productInfo.querySelectorAll('variant-selects fieldset, variant-selects select'))
        .map((control) => control.matches('select') ? control.selectedOptions[0]?.textContent.trim() : control.querySelector('input:checked')?.value)
        .filter(Boolean);

      stickyButton.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
      stickyButton.classList.toggle('loading', sourceButton.classList.contains('loading'));
      if (stickySpinner) stickySpinner.classList.toggle('hidden', !sourceButton.classList.contains('loading'));

      stickyLabel.textContent = sourceButton.querySelector('span')?.textContent.trim() || '';
      if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
      if (stickyComparePrice) {
        if (comparePrice && comparePrice.textContent.trim().length > 0) {
          stickyComparePrice.textContent = comparePrice.textContent.trim();
          stickyComparePrice.style.display = '';
        } else {
          stickyComparePrice.style.display = 'none';
        }
      }
      if (stickyVariant) stickyVariant.textContent = selections.join(' / ');

      // Sync active variant ID in stickySelect
      const formVariantInput = productInfo.querySelector('product-form input[name="id"]');
      if (stickySelect && formVariantInput && formVariantInput.value) {
        if (stickySelect.value !== formVariantInput.value) {
          stickySelect.value = formVariantInput.value;
        }
        const activeOption = stickySelect.querySelector(`option[value="${formVariantInput.value}"]`);
        if (activeOption && activeOption.dataset.image && stickyImage) {
          stickyImage.src = activeOption.dataset.image;
        }
      }
    };

    if (sticky && sourceButton) {
      sticky.hidden = false;
      syncSticky();

      if (stickySelect) {
        stickySelect.addEventListener('change', (e) => {
          const selectedId = e.target.value;
          const opt = e.target.selectedOptions[0];

          // 1. Update the hidden variant ID input in the product form
          const formVariantInput = productInfo.querySelector('product-form input[name="id"]');
          if (formVariantInput) {
            formVariantInput.value = selectedId;
            formVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // 2. Select corresponding radio in variant-selects if available
          const optText = opt ? opt.textContent.split(' — ')[0].trim() : '';
          const radios = productInfo.querySelectorAll('variant-selects input[type="radio"]');
          for (const radio of radios) {
            if (optText.includes(radio.value) || radio.value === optText) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }

          // 3. Update sticky thumbnail image if option has data-image
          if (opt && opt.dataset.image && stickyImage) {
            stickyImage.src = opt.dataset.image;
          }

          syncSticky();
        });
      }

      document.addEventListener('change', (event) => {
        if (productInfo.contains(event.target)) syncSticky();
      });
      new MutationObserver(syncSticky).observe(sourceButton, { subtree: true, childList: true, attributes: true, characterData: true });
      const priceContainer = productInfo.querySelector('[id^="price-"]');
      if (priceContainer) new MutationObserver(syncSticky).observe(priceContainer, { subtree: true, childList: true, characterData: true });
      if ('IntersectionObserver' in window) {
        let sourceVisible = true;
        let footerVisible = false;
        const updateVisibility = () => sticky.classList.toggle('is-visible', !sourceVisible && !footerVisible);
        new IntersectionObserver(([entry]) => {
          sourceVisible = entry.isIntersecting;
          updateVisibility();
        }, { threshold: 0.1 }).observe(sourceButton);
        const footer = document.querySelector('footer');
        if (footer) {
          new IntersectionObserver(([entry]) => {
            footerVisible = entry.isIntersecting;
            updateVisibility();
          }).observe(footer);
        }
      }
    }

    const gallery = productInfo.querySelector('media-gallery');
    const mediaItems = Array.from(gallery?.querySelectorAll('.product__media-list > [data-media-id]') || []);
    if (gallery && mediaItems.length > 1) {
      const mediaList = gallery.querySelector('.product__media-list');
      const pagination = document.createElement('div');
      pagination.className = 'hitch-media-pagination';
      pagination.setAttribute('aria-label', window.variantStrings?.mediaGallery || 'Galería del producto');
      mediaItems.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.classList.toggle('is-active', item.classList.contains('is-active') || index === 0);
        button.setAttribute('aria-label', `${index + 1} / ${mediaItems.length}`);
        button.addEventListener('click', () => gallery.setActiveMedia?.(item.dataset.mediaId, true));
        pagination.append(button);
      });
      gallery.append(pagination);
      const updatePagination = () => {
        const activeId = gallery.querySelector('.product__media-item.is-active')?.dataset.mediaId;
        let activeIndex = mediaItems.findIndex((item) => item.dataset.mediaId === activeId);
        if (window.matchMedia('(max-width: 749px)').matches && mediaList) {
          activeIndex = mediaItems.reduce((closest, item, index) => (
            Math.abs(item.offsetLeft - mediaList.scrollLeft) < Math.abs(mediaItems[closest].offsetLeft - mediaList.scrollLeft) ? index : closest
          ), 0);
        }
        Array.from(pagination.children).forEach((button, index) => button.classList.toggle('is-active', index === activeIndex));
      };
      new MutationObserver(updatePagination).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
      mediaList?.addEventListener('scroll', updatePagination, { passive: true });
    }
  };

  document.querySelectorAll('[data-hitch-product]').forEach(initializeProduct);
  document.addEventListener('shopify:section:load', (event) => initializeProduct(event.target));
})();
